<template>
  <section>
    <div class="flex mb-1 mt-4">
      <div :class="`font-label text-fg-secondary text-xs uppercase ${timeStyle}`">Seating Time</div>
      <div :class="`font-label text-fg-secondary text-xs uppercase ${guestsStyle}`">Max Guests</div>
    </div>
    <div v-for="(seatingTime, index) in seatingTimes" :key="index" :id="`seatingTime-${index}`">
      <SeatingTimeForm
        :seatingTime="seatingTime"
        :sharedStyle="sharedStyle"
        :timeStyle="timeStyle"
        :guestsStyle="guestsStyle"
        :uid="index.toString()"
        :deleteAlwaysAllowed="deleteAlwaysAllowed"
        @delete="onDelete(index)"
      />
    </div>
    <div
      id="no-seating-time-error-message"
      class="font-sans text-alerts-warning text-base"
      v-if="seatingTimes.length === 0"
    >
      There are no seating times. This will result in a Performance that appears to be sold out.
    </div>
    <ButtonDefault
      v-if="addEnabled"
      label="Add Seating Time"
      id="add-new-seating-time-btn"
      class="mt-2 w-8/12 sm:w-5/12"
      @click="onAddSeatingTime()"
      alt
    />
    <SlotModal
      :display="isSeatingTimeDelete"
      id="delete-seating-time-dialog"
      @close="selectedSeatingTimeIdx = -1"
    >
      <template #header>Please Confirm</template>
      <template #default>
        <div id="delete-seating-time-confirm-text" class="font-sans text-base">
          Are you sure you want to delete the
          <span class="font-semibold">{{ seatingTimes[selectedSeatingTimeIdx].time24 }}</span>
          seating time?
        </div>
        <div class="flex justify-between mt-8">
          <ButtonDefault
            label="Cancel"
            id="delete-seatingtime-dialog-cancel"
            @click="selectedSeatingTimeIdx = -1"
            alt
          />
          <ButtonDefault
            label="Yes"
            id="delete-seatingtime-dialog-proceed"
            @click="emitDelete"
            altWarning
          />
        </div>
      </template>
    </SlotModal>
  </section>
</template>

<script lang="ts">
import { mapState } from 'pinia'
import { PropType, defineComponent } from 'vue'

import ButtonDefault from '@/common/components/atoms/ButtonDefault.vue'
import SlotModal from '@/common/components/organisms/SlotModal.vue'
import SeatingTimeForm from '@/components/seatingtimes/SeatingTimeForm.vue'
import { FormSeatingTime } from '@/models'
import { useReservationStore } from '@/modules/reservation/stores/ReservationStore'

export default defineComponent({
  name: 'SeatingTimeFormList',
  components: {
    SeatingTimeForm,
    ButtonDefault,
    SlotModal,
  },
  props: {
    seatingTimes: { type: Array as PropType<FormSeatingTime[]>, required: true },
    addEnabled: { type: Boolean, default: true },
    sharedStyle: { type: String, default: 'border border-linear-subtle rounded' },
    timeStyle: { type: String, default: 'w-5/12' },
    guestsStyle: { type: String, default: 'w-3/12 mx-2' },
    deleteAlwaysAllowed: { type: Boolean, default: false },
  },
  emits: {
    // eslint-disable-next-line no-unused-vars
    delete: (_SeatingTimeIdx: number) => true,
  },
  data() {
    return {
      selectedSeatingTimeIdx: -1,
    }
  },
  computed: {
    ...mapState(useReservationStore, ['reservations']),

    isSeatingTimeDelete(): boolean {
      return this.selectedSeatingTimeIdx >= 0
    },
  },
  methods: {
    onAddSeatingTime() {
      this.seatingTimes.push({ time24: '00:00', maximum_guests: 0, deletable: true })
    },
    onDelete(index) {
      this.selectedSeatingTimeIdx = index
    },
    emitDelete() {
      this.$emit('delete', this.selectedSeatingTimeIdx)
      this.selectedSeatingTimeIdx = -1
    },
  },
})
</script>
